import { FC } from 'react';
import styled from 'styled-components';

import Card from '@/pages/MLProject/components/Card';
import { MLProjectTranslation } from '@/types/resources';
import { MLProjectTranslationStatus } from '@/utils/enums';

import ScriptPart from './ScriptPart';
import VoiceoverCard from './VoiceoverCard';

const Parts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 88px;
`;

interface Props {
  translation: MLProjectTranslation;
}

const ScriptCard: FC<Props> = ({ translation }) => {
  const originalScript = translation.project!.script!;

  return (
    <Card
      storageKey={`ml_translation_${translation.id}_script_card_visibility`}
      title="Script translation & voiceover"
      defaultIsOpened
      description="Check translated text options and approve them. Edit time stamps where needed for voiceovers"
    >
      <Parts>
        {originalScript.map((originalPart, i) => {
          const part = translation.script![i];
          const voiceoverMedia = translation.voiceovers!.find(
            (media) =>
              media.meta?.partUuid === part.uuid && !media.meta?.splittedPart,
          );

          return (
            <div key={i}>
              <ScriptPart
                translationId={translation.id}
                originalPart={originalPart}
                part={part}
              />
              <VoiceoverCard
                isFirst={i === 0}
                videoMedia={translation.project!.video}
                videoVolume={translation.settings?.videoVolume ?? 1}
                part={part}
                isDisabled={
                  translation.status === MLProjectTranslationStatus.DONE
                }
                translationId={translation.id}
                voiceoverMedia={voiceoverMedia}
              />
            </div>
          );
        })}
      </Parts>
    </Card>
  );
};

export default ScriptCard;
